import { onMounted, ref, toRaw } from 'vue'

import { defineStore } from 'pinia'

import { axiosInstance } from '@/utils/axios'

import type { Pin } from '@/interfaces'

export const usePinsStore = defineStore('pins', () => {
  const selectedPin = ref<Pin>()
  const storedPins = ref<Pin[]>([])
  const filteredPins = ref<Pin[]>([])

  function updatePin(pin: Pin) {
    const storedPinsCopy = structuredClone(toRaw(storedPins.value))

    const pinIndex = storedPinsCopy.findIndex((p) => p._id === pin._id)
    if (pinIndex > -1) {
      storedPinsCopy.splice(pinIndex, 1, pin)
    }

    storedPins.value = storedPinsCopy

    const filteredPinsCopy = structuredClone(toRaw(filteredPins.value))

    const fPinIndex = filteredPinsCopy.findIndex((p) => p._id === pin._id)
    if (fPinIndex > -1) {
      filteredPinsCopy.splice(pinIndex, 1, pin)
    }

    filteredPins.value = filteredPinsCopy

    if (selectedPin.value?._id === pin._id) {
      selectedPin.value = pin
    }
  }

  function setFilteredPins(pins: Pin[]) {
    filteredPins.value = pins
  }

  async function fetchPins() {
    const authToken = sessionStorage.getItem('authToken')

    const response = await axiosInstance.get('activities', {
      ...(authToken && { headers: { 'x-auth-token': authToken } })
    })

    storedPins.value = response.data
    filteredPins.value = response.data
  }

  function setSelectedPin(pin: Pin | undefined) {
    selectedPin.value = pin
  }

  onMounted(() => {
    fetchPins()
  })

  return {
    pins: storedPins,
    filteredPins,
    selectedPin,
    setSelectedPin,
    updatePin,
    setFilteredPins,
    fetchPins
  }
})
